export const getProfilePage = state => state.profilePage;
export const getProfile = state => state.profilePage.profile;
